"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Chooseyourjourney() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const tours = [{
    season: "3 DAY",
    name: "Ha Giang Loop Classic",
    dates: "From $228",
    difficulty: 2,
    latin: "Curated for the soul",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_mountain_road.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_mountain_road.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_mountain_road.png-wvc-sizes",
    offset: "lg:mt-0"
  }, {
    season: "4 DAY",
    name: "The Frontier Deep Dive",
    dates: "From $319",
    difficulty: 3,
    latin: "Uncharted northern paths",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_valley_view.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_valley_view.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_valley_view.png-wvc-sizes",
    offset: "lg:mt-24"
  }, {
    season: "5 DAY",
    name: "Cao Bang Expedition",
    dates: "Custom Pricing",
    difficulty: 3,
    latin: "Beyond the horizon",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_waterfall_trail.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_waterfall_trail.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_waterfall_trail.webp-wvc-sizes",
    offset: "lg:mt-12"
  }, {
    season: "JEEP",
    name: "Private Comfort Tour",
    dates: "Tailored Experience",
    difficulty: 1,
    latin: "Luxury in the wild",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_jeep_tour.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_jeep_tour.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/ha_giang_jeep_tour.webp-wvc-sizes",
    offset: "lg:mt-24"
  }];
  return <section data-section-id="916" id="chooseyourjourney" className="bg-background text-foreground py-24 md:py-32 lg:py-40">
      <div className="container mx-auto px-6 lg:px-10">
        {}
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default text-xs tracking-[0.25em] uppercase" style={{
          color: "var(--chart-1)"
        }}>
            Our Journeys &mdash; Premium Motorbike Tours
          </p>

          <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end">
            <h2 className="col-span-1 lg:col-span-7 font-default text-4xl md:text-5xl lg:text-6xl xl:text-[64px] leading-[1.05] tracking-tight text-foreground" style={{
            fontFamily: "var(--font-serif)"
          }}>
              Find your{" "}
              <span className="relative inline-block">
                frontier
                <span aria-hidden="true" className="absolute left-0 -bottom-1 h-[3px] w-full" style={{
                background: "var(--chart-1)",
                transform: "rotate(-0.5deg)"
              }} />
              </span>{" "}
              in Northern Vietnam.
            </h2>
            <p className="col-span-1 lg:col-span-4 lg:col-start-9 text-base md:text-lg leading-relaxed text-muted-foreground font-default">
              Small-group guided motorbike journeys designed for those who seek 
              the quiet beauty of the mountains and authentic local connection.
            </p>
          </div>
        </div>

        {}
        <div className="mt-20 lg:mt-28 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {tours.map((tour, i) => <TourCard key={i} data-index={i} tour={tour} index={i} />)}
        </div>

        {}
        <div className="mt-20 flex justify-center">
          <Button asChild variant="link" className="group font-default text-sm tracking-[0.15em] uppercase text-foreground hover:text-foreground hover:no-underline">
            <Link to="/OurJourneysPage">
              View all journeys
              <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1.5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}
type Tour = {
  season: string;
  name: string;
  dates: string;
  difficulty: number;
  latin: string;
  image: string;
  srcset: string;
  sizes: string;
  offset: string;
};
function TourCard({
  tour,
  index,
  ...rest
}: {
  tour: Tour;
  index: number;
} & React.HTMLAttributes<HTMLDivElement>) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <div {...rest} ref={ref} className={`group relative ${tour.offset} transition-all duration-700 ease-out`} style={{
    transitionDelay: `${index * 120}ms`,
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(32px)"
  }}>
      <div className="relative border border-transparent group-hover:border-[var(--primary)] transition-colors duration-500 p-3 rounded-lg">
        {}
        <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-muted">
          <img src={tour.image} data-wvc-srcset={tour.srcset} data-wvc-sizes={tour.sizes} alt={tour.name} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-all duration-700 ease-out group-hover:scale-[1.04] group-hover:brightness-105 group-hover:saturate-110" />

          {}
          <div className="absolute top-4 left-4 flex items-center justify-center px-3 h-10 rounded-md font-default text-[11px] font-semibold tracking-wider shadow-md" style={{
          background: "var(--primary)",
          color: "var(--primary-foreground)"
        }}>
            {tour.season}
          </div>
        </div>

        {}
        <div className="pt-6 pb-2 px-1">
          <h3 className="font-default text-2xl leading-snug text-foreground" style={{
          fontFamily: "var(--font-serif)"
        }}>
            {tour.name}
          </h3>

          <p className="mt-2 font-default text-sm text-muted-foreground">
            {tour.dates}
          </p>

          {}
          <div className="mt-4 flex items-center gap-3">
            <span className="font-default text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
              Intensity
            </span>
            <div className="flex items-center gap-1.5">
              {[0, 1, 2, 3].map(d => <span key={d} data-index={d} className="block size-2 rounded-full" style={{
              background: d < tour.difficulty ? "var(--foreground)" : "var(--border)"
            }} />)}
            </div>
          </div>

          <p className="mt-4 italic text-sm" style={{
          color: "var(--chart-1)",
          fontFamily: "var(--font-serif)"
        }}>
            {tour.latin}
          </p>

          <Link to="/ReserveYourSeatPage" className="mt-6 inline-flex items-center gap-2 font-default text-xs tracking-[0.2em] uppercase text-foreground">
            <span className="relative">
              Reserve Seat
              <span aria-hidden="true" className="absolute left-0 -bottom-1 h-px w-full origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" style={{
              background: "var(--foreground)"
            }} />
            </span>
            <ArrowRight className="size-3.5 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </div>;
}